import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Link from '@atlaskit/link';
import { Section } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';
import { gridSize, borderRadius } from '@atlassian/jira-common-styles/src/main.tsx';
import { FormattedMessage } from '@atlassian/jira-intl';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import messages from './messages.tsx';
import type { WarningProps } from './types.tsx';

export const Warning = ({ testIdPrefix }: WarningProps) => {
	const { formatMessage } = useIntl();

	const testId = testIdConcat(testIdPrefix, 'warning');

	return (
		<Section testId={testId}>
			<Wrapper>
				<FormattedMessage
					{...messages.noAdminPermissionMessage}
					values={{
						contact: (
							<Link href="/secure/ContactAdministrators!default.jspa">
								{formatMessage(messages.noAdminPermissionMessageContact)}
							</Link>
						),
					}}
				/>
			</Wrapper>
		</Section>
	);
};

export const Wrapper = ({ children }: { children: ReactNode }) => (
	<Outer>
		<Inner>{children}</Inner>
	</Outer>
);

// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Outer = styled.div({
	paddingTop: token('space.100'),
	paddingRight: token('space.250'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.250'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Inner = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	maxWidth: `${gridSize * 50}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.warning'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius,
	paddingTop: token('space.200'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.200'),
	paddingLeft: token('space.200'),
});
